import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      <footer>
        COPYRIGHT © 2022 YOUTH PROGRAMME. ALL RIGHTS RESERVED.
        <p>POWERED BY: <a href="#" target="_parent" title="National Information Technology Board (NITB)">NATIONAL INFORMATION TECHNOLOGY BOARD (NITB)</a></p>
      </footer>
    </>
  );
};

export default Footer;
